
export const ConstantsMalayalam = {
    patterns: [],
    fix_patterns: [
        {
            "search_word":"ഓ",
            "replace_word": "ഔ"
        },
        {
            "search_word":"ക",
            "replace_word":"ഖ"
        },
        {
            "search_word":"ঢ়",
            "replace_word":"ঢ়"
        },
        {
            "search_word":"য়া",
            "replace_word":"য়া"
        },
        {
            "search_word":"ড়ো",
            "replace_word":"ড়ো"
        },
        {
            "search_word":"ঢ়ো",
            "replace_word":"ঢ়ো"
        },
        {
            "search_word":"ঢ়োঁ",
            "replace_word":"ঢ়োঁ"
        },
    ],
    variations:
    {
        // അംഗഹീന (y), അംഗവിഹീന (n), വിദ്യാവിഹീന (y), വിദ്യാഹീന (n), चिंतामुक्त, करमुक्त (y)= चिंतायुक्त, करयुक्त (n), धातुनाशक (y) = धातुनाशिनी (n)
        //"মূলটা":"বিকল্পটা"
        "ର୍ଚ୍ଚ": "ର୍ଚ",
        "ର୍ଚ": "ର୍ଚ୍ଚ",
        "ର୍ଣ୍ଣ": "ର୍ଣ",
        "ର୍ତ୍ତ": "ର୍ତ",
        "ର୍ଦ୍ଦ": "ର୍ଦ",
        "ର୍ବ୍ବ": "ର୍ବ",
        "ର୍ମ୍ମ": "ର୍ମ",
        "ഹീന": "വിഹീന",
        "വിഹീന": "ഹീന",
        "അമുക്ത": "വിമുക്ത",
        "യുക്ത": "മുക്ത",
    }
}